import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, TokenState } from './types';

export const INITIAL_STATE: TokenState = {
	data: null,
};

export default function acoesUso(
	state = INITIAL_STATE,
	action: ReducerAction,
): TokenState {
	return produce(state, draft => {
		switch (action.type) {
			case Types.TOKEN_REQUEST: {
				draft.data = action.payload.token;
				break;
			}

			case Types.TOKEN_CLEAR: {
				draft.data = INITIAL_STATE.data;
				break;
			}
			default:
		}
	});
}
